<template>
    <div id="home">
        <top></top>
        <div class="mian" :style="{ height: mianH + 'px' }">
            <left></left>
            <div id="novel_main">
                <novelSuccess  :type="type" :successNovelId="successNovelId"/>
            </div>

        </div>
    </div>
</template>

<script>
import top from '@/components/top.vue' //顶部
import left from '@/components/left.vue' //左侧
import novelSuccess from '@/components/script/novel_success.vue' //创建成功
import loadingStatus from '@/components/loading_status.vue' //加载
import { EncryptionUtil } from '@/utils/encrypt'
export default {
    components: {
        top, left, novelSuccess,loadingStatus
    },
    data() {
        return {
            mianH: 0,//主题区域宽度
            type: '', //
            successNovelId: null, //创建成功小说id
            novelInfo:{},
            loading: true, //加载
        }
    },
    created() {
        this.novelInfo = this.$route.query?.novelInfo ?  EncryptionUtil.decrypt( this.$route.query.novelInfo) : {}
        this.successNovelId = this.$route.query?.successNovelId || ''
        this.type = this.$route.query?.type || ''
    },
    mounted() {
        this.calculateMianHeight();
        window.addEventListener('resize', this.calculateMianHeight);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.calculateMianHeight);
    },
    methods: {
        calculateMianHeight() {
            this.mianH = window.innerHeight - 63;
        },
        toNovellist() {
            this.$router.replace({ path: '/novel', query: {} })
        }
    }
}
</script>

<style>
#novel {
    width: 100%;
    height: 100vh;
    display: flex;
    flex-flow: column;
}

.mian {
    display: flex;
    min-width: 1500px;
}
</style>